import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconDocumentBrokenSvg } from "./IconDocumentBrokenSvg.mjs";
const IconDocumentBroken = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconDocumentBrokenSvg, ...svgProps }) });
export {
  IconDocumentBroken
};
